<button class="btn btn-primary w-100 mb-3" (click)="loadMore()" *ngIf="showLoadMore">
    {{ 'pages.loadMoreMessage' | translate }} <i class="fas fa-arrow-right pl-2"></i>
</button>